import { ConvertStatusById } from "@/utils/convert-status-to-name/convert-status-to-name";
import { StatusBedgeProps } from "./status-bedge.types";
import { cva } from "class-variance-authority";

export const StatusBedge = ({ status, type }: StatusBedgeProps) => {
  const CURRENT_STATUS_BEDGE = ConvertStatusById({ status, type });

  const badgeVariants = cva(
    "font-medium text-sm text-center w-2 h-2 rounded-full",
    {
      variants: {
        variant: {
          default: "bg-primary",
          secondary: "bg-secondary",
          destructive: "bg-destructive",
          outline: "text-foreground",
          green_300: "bg-green-300",
          lime_400: "bg-lime-400",
          green_400: "bg-green-400",
          red_400: "bg-red-400",
          yellow_400: "bg-yellow-400",
          orange_400: "bg-orange-400",
          red_300: "bg-red-300",
        },
      },
      defaultVariants: {
        variant: "default",
      },
    },
  );

  return (
    <div className="flex items-center gap-2">
      <span
        className={`${badgeVariants({ variant: CURRENT_STATUS_BEDGE?.badge_color })}`}
      />
      <span>{CURRENT_STATUS_BEDGE?.title}</span>
    </div>
  );
};
